<template>
  <div>
    <div class="invoice-loader">
      <div v-if="loadingInvoice">
        Loading invoice...
      </div>
      <div v-else-if="invoiceValid == false" class="text-center">
        Invoice not found. <br/>Please double check the URL you entered.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Client Invoice',
  props: {
    invoiceNumber: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loadingInvoice: false,
      invoiceValid: false,
    }
  },
  mounted() {
    // Log the invoice number to the console
    console.log(`Loading invoice ${this.invoiceNumber}`)
    this.FetchInvoice()
  },
  methods: {
    async FetchInvoice() {
      this.loadingInvoice = true
      const invoice = await this.$store.dispatch('ActionFetchClientInvoice', this.invoiceNumber)
      this.loadingInvoice = false
      if (invoice.success == false) {
        this.invoiceValid = false
        return
      }
      this.invoiceValid = true

      console.log('got invoice', JSON.stringify(invoice))
      const params = new  URLSearchParams({
        total: invoice.Amount,
        paymentType: 'cc',
        email: invoice.Email,
        billFName: invoice.FirstName,
        billLName: invoice.LastName,
        invoice: invoice.InvoiceNumber,
        billCompany: invoice.CompanyName,

      })
      //m&billFName=Miles&billLName=Every&invoice=1234&billCompany=IT%20Assist%20Team
      window.location.href = `${process.env.VUE_APP_INVOICE_URL}?${params}`
    }
  }
};

//{"InvoiceNumber":2686,"Amount":656.25,"CompanyName":"Siskiyou Credit Union","FirstName":"Ben ","LastName":" Woodruff","Address":"1420 Fairlane Rd","City":"Yreka","State":"CA","Zip":"96097","Country":"United States","Email":"bwoodruff@siskiyoucu.org"}

/*
{
    "InvoiceNumber": 2686,
    "Amount": 656.25,
    "CompanyName": "Siskiyou Credit Union",
    "FirstName": "Ben ",
    "LastName": " Woodruff",
    "Address": "1420 Fairlane Rd",
    "City": "Yreka",
    "State": "CA",
    "Zip": "96097",
    "Country": "United States",
    "Email": "bwoodruff@siskiyoucu.org"
}
*/
</script>

<style scoped>

.invoice-loader {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

</style>
